type GtmConsent = (action: 'default' | 'update', value: boolean) => void;

interface UseGTM {
  consent: GtmConsent;
}

window.dataLayer = window.dataLayer || [];
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function gtag(...args: unknown[]) {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

const consent = (action: 'default' | 'update', value: boolean) => {
  gtag('consent', action, {
    analytics_storage: value ? 'granted' : 'denied',
    ad_storage: value ? 'granted' : 'denied',
    ad_user_data: value ? 'granted' : 'denied',
    ad_personalization: value ? 'granted' : 'denied',
  });
};

export default (): UseGTM => ({
  consent,
});
